import { FC } from 'react';

import AuthenticationLayout from '@/components/layout/AuthenticationLayout.tsx';
import CorporateRegister from '@/components/layout/corporateRegisterPage/CorporateRegister.tsx';

const CorporateRegisterPage: FC = () => {
  return (
    <AuthenticationLayout>
      <CorporateRegister />
    </AuthenticationLayout>
  );
};

export default CorporateRegisterPage;
